<template>
  <div class="bgs-documents">
    <collapse accordion>
      <panel :name="item.name" v-for="item in bgsDocuments" :key="item.id">
        {{ item.name }}
        <div slot="content">
          <inline-loader v-if="loading" :loading="loading" />
          <bgs-resources :source="source" :file-type-id="item.id" />
        </div>
      </panel>
    </collapse>
  </div>
</template>

<script>
import BgsResources from './bgs-resources.vue'

const bgsDocuments = [
  {
    id: '9960606a-287d-46f4-9fa0-fd66631be240',
    name: 'Банковская гарантия (рабочий формат)'
  },
  {
    id: '54fe0574-3b76-4e77-862e-9ab99904c4d9',
    name: 'Банковская гарантия (сканированный вид)'
  }
]

export default {
  props: ['source'],
  components: {
    BgsResources
  },
  data () {
    return {
      loading: false,
      bgsDocuments
    }
  }
}
</script>

<style></style>
